enum ServiceApiName {
    SendGrid = 'sendgrid',
    SendGridNoNotif = 'sendgridnonotif',
    Send = 'send'
}

export default ServiceApiName;